import { loadable } from '@shared/core/loadableFromNamedExport';

// The cross-sell modal only opens on a first publish. Consumers gate its render
// behind `dialogProps.isOpen`, so this chunk loads on demand rather than sitting
// in every publish surface's (admin + guest) bundle.
export const LazyStationeryCrossSellDialog = loadable(
  () => import(/* webpackChunkName: "shared/stationery-cross-sell-dialog" */ './StationeryCrossSellDialog'),
  'StationeryCrossSellDialog',
);
